import { render, staticRenderFns } from "./appeal.vue?vue&type=template&id=63a73270&scoped=true&"
import script from "./appeal.vue?vue&type=script&lang=js&"
export * from "./appeal.vue?vue&type=script&lang=js&"
import style0 from "./appeal.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"
import style1 from "./appeal.vue?vue&type=style&index=1&id=63a73270&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a73270",
  null
  
)

export default component.exports